import { render, staticRenderFns } from "./sub-bg-image.vue?vue&type=template&id=244edabe&scoped=true&"
import script from "./sub-bg-image.vue?vue&type=script&lang=js&"
export * from "./sub-bg-image.vue?vue&type=script&lang=js&"
import style0 from "./sub-bg-image.vue?vue&type=style&index=0&id=244edabe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244edabe",
  null
  
)

export default component.exports